import { computed } from 'vue'

const userSubmit = (userData, companyData, errorObj) => {
  // computed func fire and provide data objects
  const isUserDataSubmitAllowed = getDisabled(userData, errorObj)
  const isCompanyDataSubmitAllowed = getDisabled(companyData, errorObj)

  return { isUserDataSubmitAllowed, isCompanyDataSubmitAllowed }
}

const getDisabled = (formData, errorObj) => {
  // computed func to check if inputs are empty or errors existing
  return computed(() => {
    let isDisabled = true

    for (const prop in formData) {
      if (!formData[prop] || errorObj[prop]) {
        isDisabled = true
        break
      }
      isDisabled = false
    }

    return isDisabled
  })
}

export default userSubmit
